import React from 'react';

import { ErrorCard } from './RouteErrorPage.jsx';

/**
 * Last line of defence around the whole app (App.jsx): an error outside any route - in the store, the auth provider,
 * a status bar - would otherwise leave a white page. Shows the same card as a failed route: reload, home, sign in.
 */
class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('App error:', error, info?.componentStack);
    }

    render() {
        if (this.state.error) return <ErrorCard error={this.state.error} />;
        return this.props.children;
    }
}

export default AppErrorBoundary;
